import { render, staticRenderFns } from "./DocumentosValidar.vue?vue&type=template&id=375b5a81"
import script from "./DocumentosValidar.vue?vue&type=script&lang=js"
export * from "./DocumentosValidar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports